import createIcon from '@/lib/create-icon'

const CopyIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M15 7H7V5C7 3.89543 7.89543 3 9 3H19C20.1046 3 21 3.89543 21 5V15C21 16.1046 20.1046 17 19 17H17V9M15 7C16.1046 7 17 7.89543 17 9M15 7H5C3.89543 7 3 7.89543 3 9V19C3 20.1046 3.89543 21 5 21H15C16.1046 21 17 20.1046 17 19V9'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    />
  </svg>,
  'CopyIcon'
)

export default CopyIcon
